import _ from 'underscore';

const selectedIdKey = 'auction-insight-ids';

export function navigateToLegacyAuctionInsights(pluginConfig, selectedItems = null) {
  const { state, legacyRouter, route } = pluginConfig;

  if (_.isArray(selectedItems)) {
    const selectedIds = _.pluck(selectedItems, 'Id');
    state.set(selectedIdKey, selectedIds);
  }

  legacyRouter.navigateToRoute(route);
}
